import { Component, Input, OnInit } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { CalendarOutlineIconComponent } from '../icons/calendar-outline-icon/calendar-outline-icon.component';
import { CalendarXIconComponent } from '../icons/calendar-x-icon/calendar-x-icon.component';
import { CrownOutlineIconComponent } from '../icons/crown-outline-icon/crown-outline-icon.component';

enum URGENCY_LEVEL {
  NORMAL = 'normal',
  WARNING = 'warning',
  CRITICAL = 'critical',
  URGENT = 'urgent'
}

@Component({
  selector: 'app-free-trial-banner',
  imports: [NgClass, NgIf, CalendarOutlineIconComponent, CalendarXIconComponent, CrownOutlineIconComponent],
  templateUrl: './free-trial-banner.component.html',
  styleUrl: './free-trial-banner.component.scss'
})
export class FreeTrialBannerComponent implements OnInit {
  @Input({ required: true }) daysLeft!: number;
  @Input() isExpired: boolean = false;

  readonly promotionalText = 'Access more brands, deeper competitor comparisons, AI Presence, and more.';

  isLastDay: boolean = false;
  isTrialEnded: boolean = false;
  urgencyLevel: URGENCY_LEVEL = URGENCY_LEVEL.NORMAL;
  statusText: string = '';
  buttonText: string = '';

  ngOnInit(): void {
    this.isLastDay = this.daysLeft === 0 && !this.isExpired;
    this.isTrialEnded = this.isExpired || this.daysLeft < 0;
    this.urgencyLevel = this.calculateUrgencyLevel();
    this.statusText = this.calculateStatusText();
    this.buttonText = this.isTrialEnded ? 'Upgrade now' : 'Contact us to upgrade';
  }

  private calculateUrgencyLevel(): URGENCY_LEVEL {
    if (this.isTrialEnded) {
      return URGENCY_LEVEL.URGENT;
    }
    if (this.daysLeft <= 3) {
      return URGENCY_LEVEL.CRITICAL;
    }
    if (this.daysLeft <= 6) {
      return URGENCY_LEVEL.WARNING;
    }
    return URGENCY_LEVEL.NORMAL;
  }

  private calculateStatusText(): string {
    if (this.isTrialEnded) {
      return 'Your trial has ended';
    }
    if (this.isLastDay) {
      return 'Last day of your trial';
    }
    const dayWord = this.daysLeft === 1 ? 'day' : 'days';
    return `${this.daysLeft} ${dayWord} left in trial`;
  }

  onUpgradeClick(): void {
    // TODO: Replace with the actual upgrade URL
    window.open('https://browsi.com/demo/', '_blank');
  }
}
